'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
import { ChevronRightGlyph } from '../../../internal/icons.js';
import { IconButton } from '../../actions/button/index.js';
/** Which page numbers to show: first, last, and a window around the current page. */
export function pageWindow(page, pageCount, radius = 1) {
    if (pageCount <= 7)
        return Array.from({ length: pageCount }, (_, i) => i + 1);
    const pages = new Set([1, pageCount]);
    for (let p = page - radius; p <= page + radius; p++)
        if (p >= 1 && p <= pageCount)
            pages.add(p);
    if (page <= 3)
        [2, 3, 4].forEach((p) => pages.add(p));
    if (page >= pageCount - 2)
        [pageCount - 3, pageCount - 2, pageCount - 1].forEach((p) => pages.add(p));
    const sorted = [...pages].sort((a, b) => a - b);
    const out = [];
    sorted.forEach((p, i) => {
        const prev = sorted[i - 1];
        if (prev !== undefined && p - prev > 1)
            out.push('gap');
        out.push(p);
    });
    return out;
}
export function Pagination({ page, pageCount, onPageChange, variant = 'full', pageSize, totalItems, label = 'Pagination', className, }) {
    const prev = (_jsx(IconButton, { label: "Previous page", size: "sm", disabled: page <= 1, onClick: () => onPageChange(page - 1), icon: _jsx(ChevronRightGlyph, { style: { transform: 'rotate(180deg)' } }) }));
    const next = (_jsx(IconButton, { label: "Next page", size: "sm", disabled: page >= pageCount, onClick: () => onPageChange(page + 1), icon: _jsx(ChevronRightGlyph, {}) }));
    if (variant === 'compact') {
        const start = pageSize && totalItems ? Math.min((page - 1) * pageSize + 1, totalItems) : undefined;
        const end = pageSize && totalItems ? Math.min(page * pageSize, totalItems) : undefined;
        return (_jsxs("nav", { "aria-label": label, className: cx('mn-pagination', className), "data-variant": "compact", children: [_jsx("p", { className: "mn-pagination__range", "aria-live": "polite", children: start !== undefined && end !== undefined
                        ? `${start}–${end} of ${totalItems}`
                        : `Page ${page} of ${pageCount}` }), prev, next] }));
    }
    return (_jsxs("nav", { "aria-label": label, className: cx('mn-pagination', className), "data-variant": "full", children: [prev, _jsx("ol", { className: "mn-pagination__pages", children: pageWindow(page, pageCount).map((p, i) => p === 'gap' ? (_jsx("li", { className: "mn-pagination__gap", "aria-hidden": true, children: "\u2026" }, `gap-${i}`)) : (_jsx("li", { children: _jsx("button", { type: "button", className: "mn-pagination__page", "aria-current": p === page ? 'page' : undefined, "aria-label": `Page ${p}`, onClick: () => onPageChange(p), children: p }) }, p))) }), next] }));
}
//# sourceMappingURL=pagination.js.map